import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconIdCard = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke="none"
        strokeWidth={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.85793 21.0001H19.1623C19.2811 21.0004 19.3985 20.9762 19.5067 20.9293C19.6149 20.8824 19.7115 20.8138 19.7899 20.7282C19.9276 20.5752 20.0023 20.379 19.9999 20.1767V3.82426C20.0023 3.62196 19.9276 3.42581 19.7899 3.27283C19.7114 3.18706 19.6148 3.11838 19.5065 3.07141C19.3982 3.02444 19.2808 3.00026 19.1619 3.00049H4.83805C4.71918 3.00026 4.60163 3.02443 4.49327 3.0714C4.38492 3.11837 4.28825 3.18705 4.20974 3.27283C4.07233 3.42597 3.99777 3.62204 4.00005 3.82426V20.1947C3.99973 20.3089 4.02482 20.4219 4.07362 20.526C4.12242 20.6302 4.19382 20.7231 4.28302 20.7986C4.44268 20.9309 4.64713 21.0026 4.85793 21.0001ZM18.3243 19.3893H5.67643V4.61094H18.3243V19.3893ZM8.73036 13.8H15.2696C15.4633 13.8 15.6491 13.7052 15.7861 13.5364C15.9231 13.3676 16 13.1387 16 12.9C16 12.6613 15.9231 12.4324 15.7861 12.2636C15.6491 12.0948 15.4633 12 15.2696 12H8.73036C8.53666 12 8.35089 12.0948 8.21392 12.2636C8.07695 12.4324 8 12.6613 8 12.9C8 13.1387 8.07695 13.3676 8.21392 13.5364C8.35089 13.7052 8.53666 13.8 8.73036 13.8ZM15.2696 16.8H8.73036C8.53666 16.8 8.35089 16.7052 8.21392 16.5364C8.07695 16.3676 8 16.1387 8 15.9C8 15.6613 8.07695 15.4324 8.21392 15.2636C8.35089 15.0948 8.53666 15 8.73036 15H15.2696C15.4633 15 15.6491 15.0948 15.7861 15.2636C15.9231 15.4324 16 15.6613 16 15.9C16 16.1387 15.9231 16.3676 15.7861 16.5364C15.6491 16.7052 15.4633 16.8 15.2696 16.8ZM12 11.2C13.215 11.2 14.2 10.215 14.2 9C14.2 7.78497 13.215 6.8 12 6.8C10.785 6.8 9.8 7.78497 9.8 9C9.8 10.215 10.785 11.2 12 11.2ZM13 9C13 9.55228 12.5523 10 12 10C11.4477 10 11 9.55228 11 9C11 8.44772 11.4477 8 12 8C12.5523 8 13 8.44772 13 9Z"
        />
      </svg>
    );
  }
);
